import { render } from "./Sala9It.vue?vue&type=template&id=214a0a78"
import script from "./Sala9It.vue?vue&type=script&lang=js"
export * from "./Sala9It.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__